import { FC, useState, ReactNode, useEffect } from 'react'
import { Box } from '@mui/material'
import { App } from '../../typings/App'
import { Header } from '../Header'
import { Drawer } from '../Drawer'
import { useUIMode } from '../../wms/src/context/UIContext'

interface Props {
    apps?: App[]
    children?: ReactNode
}

const SELECTED_NAME_KEY = 'wms_selected_page_name'

export const Layout: FC<Props> = ({
    apps,
    children
}) => {
    const [drawerOpen, setDrawerOpen] = useState(false)
    const [selectedName, setSelectedName] = useState<string | null>(() => {
        if (typeof window !== 'undefined') {
            return sessionStorage.getItem(SELECTED_NAME_KEY)
        }
        return null
    })
    const { isMobile } = useUIMode()

    // Persist selectedName to sessionStorage whenever it changes
    useEffect(() => {
        if (selectedName) {
            sessionStorage.setItem(SELECTED_NAME_KEY, selectedName)
        } else {
            sessionStorage.removeItem(SELECTED_NAME_KEY)
        }
    }, [selectedName])

    const handleDrawerClose = () => {
        if (isMobile) {
            setDrawerOpen(false);
        }
    }

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <Header
                onMenu={() => setDrawerOpen(!drawerOpen)}
                showMenu={isMobile}
                selectedName={selectedName}
                isOpen={drawerOpen}
            />
            <Drawer
                isOpen={!(isMobile && !drawerOpen)}
                apps={apps}
                onClose={handleDrawerClose}
                onSelectName={setSelectedName}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    width: '100%',
                    minHeight: 'var(--app-vh)',
                    p: (muiTheme) => muiTheme.spacing(3, 2),
                    backgroundColor: '#f5f5f5'
                }}
            >
                <Box sx={(theme) => theme.mixins.toolbar} />
                { children }
            </Box>
        </Box>
    )
}
